import React, { useState } from 'react';
import { ChevronsLeftRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { ui } from '../data/ui';
import { fill } from '../utils/format';
import type { GalleryItem } from '../types/content';
export function BeforeAfterSlider({
  item
}: {
  item: GalleryItem;
}) {
  const {
    t
  } = useLanguage();
  const [pos, setPos] = useState(50);
  return <figure data-id="element-18" data-mp="3d0x4goteq1kr">
      <div className="relative aspect-[4/3] select-none overflow-hidden rounded-2xl bg-line ring-offset-2 focus-within:ring-2 focus-within:ring-navy" data-id="element-19" data-mp="3d0f0f60i6j2a">
        <img src={item.after} alt={t(item.afterAlt)} loading="lazy" className="absolute inset-0 h-full w-full object-cover" draggable={false} data-id="element-20" data-mp="3m2ehfybipn58" />
        <div className="absolute inset-0" style={{
        clipPath: `inset(0 ${100 - pos}% 0 0)`
      }} data-id="element-21" data-mp="3i1uj4rf7kdhi">
          <img src={item.before} alt={t(item.beforeAlt)} loading="lazy" className="h-full w-full object-cover" draggable={false} data-id="element-22" data-mp="1rpev7mcmtuoz" />
        </div>

        <span className="absolute left-3 top-3 rounded-md bg-ink/85 px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-23" data-mp="1np4ryhg85idt">{t(ui.gallery.before)}</span>
        <span className="absolute right-3 top-3 rounded-md bg-leaf-strong px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-24" data-mp="1dlphwj8xao0a">{t(ui.gallery.after)}</span>

        <div className="pointer-events-none absolute inset-y-0" style={{
        left: `${pos}%`
      }} aria-hidden="true" data-id="element-25" data-mp="1nb91jr4gmlw7">
          <div className="absolute inset-y-0 w-0.5 -translate-x-1/2 bg-white" data-id="element-26" data-mp="1saloscz8tuzb" />
          <div className="absolute top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-navy shadow-lg" data-id="element-27" data-mp="1wb5ljffwmwkx">
            <ChevronsLeftRightIcon className="h-5 w-5" data-id="element-28" data-mp="218fev66ezse1" />
          </div>
        </div>

        <input type="range" min={0} max={100} value={pos} onChange={e => setPos(Number(e.target.value))} aria-label={fill(t(ui.gallery.drag), {
        title: t(item.title)
      })} className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0" data-id="element-29" data-mp="268tp8uvhnef8" />
      </div>
      <figcaption className="mt-4" data-id="element-30" data-mp="3vyoq7n6n374v">
        <p className="text-sm font-semibold text-leaf-strong" data-id="element-31" data-mp="3vzqdqr4udm3h">
          {t(item.category)} · {item.location}
        </p>
        <p className="mt-1 font-display text-lg font-bold text-ink" data-id="element-32" data-mp="dun2sps72fv5">{t(item.title)}</p>
        <p className="mt-1 text-body" data-id="element-33" data-mp="8t7jb25o0hev">{t(item.description)}</p>
      </figcaption>
    </figure>;
}